import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {SquadClickEvent} from "../models/events/squad-click-event";

export class SquadClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.squadClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = SquadClickEvent;
  }
}
